import {
  DocumentNode,
  OperationDefinitionNode,
  SelectionSetNode,
  FieldNode,
  VariableDefinitionNode,
} from 'graphql';

/**
 * Creates a selection set from object. This is the eqivalent
 * of what is returned from gql`query {}` where it includes a
 * selection set of fields based on the object provided
 */
const selectionSetFromObj = (obj: unknown): SelectionSetNode | null => {
  if (
    typeof obj === 'number' ||
    typeof obj === 'boolean' ||
    typeof obj === 'string' ||
    typeof obj === 'undefined' ||
    obj === null
  ) {
    // No selection set here
    return null;
  }

  if (Array.isArray(obj)) {
    // GraphQL queries don't include arrays
    return selectionSetFromObj(obj[0]);
  }

  // Now we know it's an object
  const selections: FieldNode[] = [];

  Object.keys(obj as { [key: string]: unknown }).forEach((key) => {
    const nestedSelSet: SelectionSetNode | null = selectionSetFromObj(
      (obj as { [key: string]: unknown })[key],
    );

    const field: FieldNode = {
      kind: 'Field',
      name: {
        kind: 'Name',
        value: key,
      },
      selectionSet: nestedSelSet || undefined,
    };
    selections.push(field);
  });

  const selectionSet: SelectionSetNode = {
    kind: 'SelectionSet',
    selections,
  };

  return selectionSet;
};

export const queryFromPojo = (
  obj: unknown,
  variables?: { id: string },
): DocumentNode => {
  const selectionSet = selectionSetFromObj(obj) || {
    kind: 'SelectionSet',
    selections: [],
  };

  const variableDefinitions: VariableDefinitionNode[] = Object.keys(
    variables || {},
  ).map(() => ({
    directives: [],
    kind: 'VariableDefinition',
    type: {
      kind: 'NonNullType',
      type: {
        kind: 'NamedType',
        name: {
          kind: 'Name',
          value: 'ID',
        },
      },
    },
    variable: {
      kind: 'Variable',
      name: {
        kind: 'Name',
        value: 'id',
      },
    },
  }));

  if (selectionSet.selections[0]) {
    // @ts-ignore
    selectionSet.selections[0].arguments = [
      {
        kind: 'Argument',
        name: {
          kind: 'Name',
          value: 'id',
        },
        value: {
          kind: 'Variable',
          name: {
            kind: 'Name',
            value: 'id',
          },
        },
      },
    ];
  }

  const op: OperationDefinitionNode = {
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'GeneratedClientQuery',
    },
    selectionSet,
    variableDefinitions,
  };

  const out: DocumentNode = {
    kind: 'Document',
    definitions: [op],
  };

  return out;
};
